module.exports = __webpack_public_path__ + "static/media/cd_exe.ff34a4a7.ico";